export default __webpack_public_path__ + "static/media/llm_arena.f954436a.PNG";